import { OrganizationId } from '@kaizenplatform/kaizen-id-entity';
import Store from 'repatch';

import State from '../core/State';
import { OrganizationDetailFragment } from '../generated/graphql';
import ErrorPresenter from '../service/ErrorPresenter';
import OrganizationWebApi from '../service/persistent/OrganizationWebApi';
import { setLastAccessedOrganization } from '../thunk/lastAccessedOrganization';

class SelectDirectionTypeUsecase {
  private readonly store: Store<State>;
  private readonly organizationWebApi: OrganizationWebApi;
  private readonly errorPresenter: ErrorPresenter;

  constructor({
    store,
    organizationWebApi,
    errorPresenter,
  }: {
    store: Store<State>;
    organizationWebApi: OrganizationWebApi;
    errorPresenter: ErrorPresenter;
  }) {
    this.store = store;
    this.organizationWebApi = organizationWebApi;
    this.errorPresenter = errorPresenter;
  }

  public prepare = async (organizationId: OrganizationId): Promise<void> => {
    let organization: OrganizationDetailFragment;

    try {
      organization = await this.organizationWebApi.getById(organizationId);
    } catch (error) {
      this.errorPresenter.showAsFatal(error);
      return;
    }

    this.store.dispatch(setLastAccessedOrganization(organization));
  };
}

export default SelectDirectionTypeUsecase;
